(function() {
  'use strict';

  angular.module('cfn').directive('cfnDashboardAlerts', cfnDashboardAlerts);

  cfnDashboardAlerts.$inject = [
    '$http',
    'dateFilter',
    'numberFilter',
    '$dialog',
    'ShopService',
    'i18nFilter',
    '$location'
  ];

  function cfnDashboardAlerts(
    $http,
    dateFilter,
    numberFilter,
    $dialog,
    ShopService,
    i18nFilter,
    $location
  ) {
    return {
      restrict: 'E',
      templateUrl: require('./alerts.html'),
      link: function(scope) {

        scope.invalidEntities = [];

        scope.activateFirstSteps = function() {
          app.showFirstSteps = true;
        };
        if (ShopService.isProductLicensed('ISIP')) {
          $http
            .get('/365FarmNet/rest/isip/septoria/notification')
            .then(function(response) {
              var notification = response.data;
              if (notification) {
                notification.infectionDateFormatted = dateFilter(
                  notification.infectionDate
                );
                notification.areaFormatted = numberFilter(notification.area, 2);
                scope.septoriaNotification = notification;
              }
            });
        }

        // DairyNet: show alert if there are any preliminary bookings
        var isGEALicensed = ShopService.isProductLicensed('GEA');
        if (isGEALicensed) {
          scope.showPointer = function(message) {
            return message.openHitImportOnClick || message.url;
          };

          scope.openHitReport = function() {
            var wizardcontroller = 'hitReportWizardController';
            // TODO: clear if `hitReportWizard.html` must be required
            var wizardtemplate =
              '/365FarmNet/mod/dairynet.herdmanagement/hitReportWizard.html';

            $dialog
              .dialog({
                backdropClick: false,
                dialogClass: 'wizard-modal'
              })
              .open(wizardtemplate, wizardcontroller);
          };

          scope.clickOnMessage = function(message) {
            if (message.openHitImportOnClick) {
              scope.openHitReport();
            } else {
              if (message.url) {
                $location.path(message.url);
              }
            }
          };

          scope.getClassFromSeverity = function(message) {
            if (message.severity === 'Critical') {
              return 'critical';
            } else if (message.severity === 'Good') {
              return 'good';
            }
          };

          $http
            .get('/365FarmNet/mod/dairynet.presentation/dashboard/messages')
            .then(function(response) {
              var dashboardMessages = response.data;
              dashboardMessages.forEach(function(message) {
                message.translatedMessage = i18nFilter(
                  message.i18nString,
                  message.i18nString,
                  message.messageParameter
                );
              });
              scope.geaMessages = dashboardMessages;
            });
        }
      }
    };
  }
})();
